module.exports = __webpack_public_path__ + "fc5fbabb5e708601f81a67252ac48322.jpg";